import CreditsForCaseToCase from '@custom/Settings/Pricing/CreditsForCaseToCase';
import React from 'react'
import Header from "../Header/Header";

const CaseCredit = () => {
  return (
    <div>
       <Header title=' Credits for case-to-case Settings' isBack={false} />
      <>
        <CreditsForCaseToCase />
      </>
    </div>
  )
}

export default CaseCredit
